import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "sf-cookie-consent";

function hasConsent() {
  return localStorage.getItem(CONSENT_KEY) === "all";
}

function loadPixel() {
  if (!PIXEL_ID || window.__fbPixelLoaded) return;
  window.__fbPixelLoaded = true;
  if (!window.fbq) {
    const n = (window.fbq = function (...args) {
      n.callMethod ? n.callMethod(...args) : n.queue.push(args);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
  }
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  script.onload = () => {
    window.fbq("init", PIXEL_ID);
    window.fbq("consent", "grant");
  };
  document.head.appendChild(script);
}

export function trackMetaLead() {
  if (window.__fbPixelLoaded && window.fbq && hasConsent()) {
    window.fbq("track", "Lead");
  }
}

export default function MetaPixel() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!PIXEL_ID) return undefined;
    const maybeLoad = () => {
      if (!hasConsent()) return;
      const wasLoaded = window.__fbPixelLoaded;
      loadPixel();
      if (!wasLoaded && window.__fbPixelLoaded) {
        const path = window.location.pathname;
        if (!path.startsWith("/admin") && !path.startsWith("/login")) {
          window.fbq("track", "PageView");
        }
      }
    };
    maybeLoad();
    window.addEventListener("cookie-consent-changed", maybeLoad);
    return () => window.removeEventListener("cookie-consent-changed", maybeLoad);
  }, []);

  useEffect(() => {
    if (!PIXEL_ID || !window.__fbPixelLoaded || !window.fbq) return;
    if (pathname.startsWith("/admin") || pathname.startsWith("/login")) return;
    window.fbq("track", "PageView");
  }, [pathname]);

  return null;
}
